import React from "react";
import ExlyInput from "repoV2/features/Common/modules/Form/modules/ExlyInput/ExlyInput";
import { classNames } from "repoV2/utils/common/render/classNames";
import { IParagraphText } from "./ParagraphText.interfaces";

const ParagraphText = (props: IParagraphText) => {
    const {
        title,
        name,
        placeholder,
        onBlur,
        validator,
        maxLength,
        classes,
        isRequired,
    } = props;

    return (
        <div className={classes.container}>
            <div className={classes.questionInput}>
                {title}&nbsp;
                {!isRequired && (
                    <span className={classes.optionalQuestionInput}>
                        (Optional)
                    </span>
                )}
            </div>
            <ExlyInput
                name={name}
                classes={{
                    helperText: classes.helperText,
                }}
                registerOptions={{
                    validate: validator,
                }}
                overrideInputProps={{
                    placeholder,
                    fullWidth: true,
                    onBlur,
                    InputProps: {
                        className: classNames(
                            classes.textInput,
                            classes.textAreaInput
                        ),
                    },
                    inputProps: {
                        ...(maxLength && {
                            maxLength,
                        }),
                    },
                    className: classes.inputCustomStyles,
                    multiline: true,
                    rows: 4,
                }}
            />
        </div>
    );
};

export default ParagraphText;
